import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import searchInput from './search/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  searchInput,
});

export default reducers;